// extracted by mini-css-extract-plugin
export var questionnairerequest = "style-module--questionnairerequest--U324B";
export var questionnairerequest_image = "style-module--questionnairerequest_image--ORiZA";
export var questionnairerequest_title = "style-module--questionnairerequest_title--1GDTu";
export var questionnairerequest_description = "style-module--questionnairerequest_description--eFSKC";
export var questionnairerequest_copyid = "style-module--questionnairerequest_copyid--8FXF8";
export var questionnairerequest_buttons = "style-module--questionnairerequest_buttons--hftyW";
export var image = "style-module--image--sMcwe";
export var image_1 = "style-module--image_1--Z0qOo";
export var image_2 = "style-module--image_2--UkhUV";
export var copyid = "style-module--copyid--KOtNy";
export var copyid_icon = "style-module--copyid_icon--MQ8EA";
export var copyid_text = "style-module--copyid_text--wp6I4";
export var buttons = "style-module--buttons--9Dbrn";
export var buttons_item = "style-module--buttons_item--Xti+J";